const resettingStyles = `* {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    html {
      min-height: -webkit-fill-available;
      tap-highlight-color: transparent;
      text-rendering: optimizeLegibility;
      font-feature-settings: normal;
      overscroll-behavior: none;
      -webkit-font-smoothing: antialiased;
      -webkit-text-size-adjust: none;
      -webkit-overflow-scrolling: touch;
      }
      a {
        text-decoration: none;
      }
      iframe {
        border: none;
        outline: none;
      }
      button {
        border: none;
        background: none;
      }
      input, textarea, select {
        border: none;
        outline: none;
        background: none;
      }
      input, select {
        appearance: none;
      }
      input, button, textarea, select {
        font-family: inherit;
      }
      a, button, input, textarea, select, div {
        -webkit-tap-highlight-color: transparent;
      }
      ul, ol {
        list-style: none;
        padding: 0;
      }
    `;

export { resettingStyles };
